import { useEffect, useState } from 'react';

const getDisplayWilayah = (wilayah) => {
  if (typeof wilayah !== 'string') return '-';
  const trimmed = wilayah.trim();
  return trimmed ? trimmed : '-';
};

const ProfileView = ({ user, onLogout, onUpdateProfile }) => {
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState(user?.name || '');
  const [phone, setPhone] = useState(user?.phone || '');
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (editing) return;
    setName(user?.name || '');
    setPhone(user?.phone || '');
  }, [user?.name, user?.phone, editing]);

  const companyName = user?.company_name || user?.company?.name || '-';
  const wilayah = getDisplayWilayah(user?.wilayah);

  const handleSave = async (e) => {
    e.preventDefault();
    const errs = {};
    if (!name.trim()) errs.name = 'Nama tidak boleh kosong';
    if (Object.keys(errs).length > 0) {
      setErrors(errs);
      return;
    }

    setSaving(true);
    try {
      await onUpdateProfile({ name: name.trim(), phone: phone.trim() || null });
      setEditing(false);
      setErrors({});
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setName(user?.name || '');
    setPhone(user?.phone || '');
    setErrors({});
    setEditing(false);
  };

  return (
    <div className="profile-view">
      <div className="profile-avatar">{(user?.name || '?').charAt(0).toUpperCase()}</div>
      <div className="profile-name">{user?.name}</div>
      <div className="profile-email">{user?.email}</div>

      <div className="profile-section-label">Informasi Akun</div>
      <div className="profile-card">
        <div className="profile-card__row">
          <span className="profile-card__label">Nama</span>
          <span className="profile-card__value">{user?.name}</span>
        </div>
        <div className="profile-card__row">
          <span className="profile-card__label">Email</span>
          <span className="profile-card__value">{user?.email}</span>
        </div>
        <div className="profile-card__row">
          <span className="profile-card__label">No. HP</span>
          <span className="profile-card__value">{user?.phone || '-'}</span>
        </div>
        <div className="profile-card__row">
          <span className="profile-card__label">Role</span>
          <span className="profile-card__value">Employee</span>
        </div>
        <div className="profile-card__row">
          <span className="profile-card__label">Perusahaan</span>
          <span className="profile-card__value">{companyName}</span>
        </div>
        <div className="profile-card__row">
          <span className="profile-card__label">Wilayah</span>
          <span className="profile-card__value">{wilayah}</span>
        </div>
      </div>

      {!editing ? (
        <button className="btn btn-outline profile-edit-btn" onClick={() => setEditing(true)}>
          Edit Profil
        </button>
      ) : (
        <div className="profile-edit-form">
          <div className="profile-section-label">Edit Profil</div>
          <form onSubmit={handleSave}>
            <div className="form-group">
              <label>Nama</label>
              <input
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setErrors((p) => ({ ...p, name: undefined }));
                }}
                className={errors.name ? 'error' : ''}
                placeholder="Masukkan nama"
              />
              {errors.name && <span className="error-msg">{errors.name}</span>}
            </div>
            <div className="form-group">
              <label>
                No. HP <span className="form-optional">(opsional)</span>
              </label>
              <input
                type="tel"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Masukkan nomor HP"
              />
            </div>
            <div className="profile-edit-actions">
              <button type="button" className="btn btn-outline" onClick={handleCancel} disabled={saving}>
                Batal
              </button>
              <button type="submit" className="btn btn-primary" disabled={saving}>
                {saving ? 'Menyimpan...' : 'Simpan'}
              </button>
            </div>
          </form>
        </div>
      )}

      <button className="profile-logout" onClick={onLogout}>
        Keluar
      </button>

      <div className="profile-footer-space" />
    </div>
  );
};

export default ProfileView;
